module.exports = __webpack_public_path__ + "img/img-auth-sideimg5.10826752.png";